import TemplateTitle from './TemplateTitle';
import MyCarousel from '@/components/Carousel';
import { CAROUSEL_SETTINGS } from '&/constants/index';
import SlickArrowLeft from '&/components/Carousel/SlickArrowLeft';
import SlickArrowRight from '&/components/Carousel/SlickArrowRight';
import './common.scss';
import './Template02.scss';
export default function (props) {
    const pics = [
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/01.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/02.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/03.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/04.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/05.png')
                .default,
        },
    ];
    const smallPics = [
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/01_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/02_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/03_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/04_s.png')
                .default,
        },
        {
            img: require('@/assets/img/landing/example/template_1/lunbo/05_s.png')
                .default,
        },
    ];
    return (
        <div className="landing-template-two landing-template-common">
            <div className="header">
                <div className="header-title">
                    {intl.get('landingPage.template2.message1')}
                </div>
            </div>
            <section className="session-one">
                <div className="sub-content">
                    <TemplateTitle
                        title={intl.get('landingPage.template2.message2')}
                        subTitle={intl.get('landingPage.template2.message3')}
                    />
                    <div className="medium-title medium-title-first">
                        {intl.get('landingPage.template2.message4')}
                    </div>
                    <div className="arrow">
                        <img
                            className="img-first"
                            src={
                                require('@/assets/img/landing/example/template_1/group.png')
                                    .default
                            }></img>
                    </div>
                    <div className="medium-title">
                        {intl.get('landingPage.template2.message5')}
                    </div>
                    <div className="arrow">
                        <img
                            className="img-second"
                            src={
                                require('@/assets/img/landing/example/template_1/group_1.png')
                                    .default
                            }></img>
                    </div>
                </div>
            </section>
            <section className="section-two">
                <div className="header-absolute">
                    <div className="big-title">
                        {intl.get('landingPage.template2.message9')}
                    </div>
                    <div className="small-title">
                        {intl.get('landingPage.template2.message10')}
                    </div>
                </div>
                <img
                    src={
                        require('@/assets/img/landing/example/template_1/member.png')
                            .default
                    }></img>
            </section>
            <section className="section-three">
                <div className="sub-content">
                    <TemplateTitle
                        title={intl.get('landingPage.template2.message6')}
                        subTitle=""
                    />
                    <MyCarousel
                        {...CAROUSEL_SETTINGS}
                        pics={pics}
                        imgWidth={158}
                        navGap={20}
                        dotsTotalWidth={970}
                        arrow={true}
                        selectNum={0}
                        smallPics={smallPics}
                        prevArrow={<SlickArrowLeft loop />}
                        nextArrow={<SlickArrowRight loop />}
                    />
                </div>
            </section>

            <section className="section-four">
                <div className="sub-content">
                    <div className="company-wrap">
                        <div className="title">
                            <img
                                src={
                                    require('@/assets/img/landing/logo2@2x.png')
                                        .default
                                }></img>
                            <span>
                                {intl.get('landingPage.template2.message7')}
                            </span>
                        </div>
                        <div className="desc">
                            {intl.get('landingPage.template2.message8')}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
